import { HasAuthority } from "context/authority";
import Authority from "shared/enums/Authority";
import { AnyObject } from "global";

export function HasPlatformConfigWriteAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.PLATFORM_CONFIG_WRITE}>{props.children}</HasAuthority>;
}

export function HasPlatformConfigReadAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.PLATFORM_CONFIG_READ}>{props.children}</HasAuthority>;
}

export function HasPlatformUserWriteAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.PLATFORM_USER_WRITE}>{props.children}</HasAuthority>;
}

export function HasPlatformUserReadAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.PLATFORM_USER_READ}>{props.children}</HasAuthority>;
}

export function HasPlatformClientWriteAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.PLATFORM_CLIENT_WRITE}>{props.children}</HasAuthority>;
}

export function HasPlatformClientReadAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.PLATFORM_CLIENT_READ}>{props.children}</HasAuthority>;
}

export function HasPlatformEventSeriesCreateAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.PLATFORM_EVENT_SERIES_CREATE}>{props.children}</HasAuthority>;
}

export function HasEventSeriesWriteAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.EVENT_SERIES_WRITE}>{props.children}</HasAuthority>;
}

export function HasEventSeriesReadAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.EVENT_SERIES_READ}>{props.children}</HasAuthority>;
}

export function HasEventSeriesUserWriteAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.EVENT_SERIES_USER_WRITE}>{props.children}</HasAuthority>;
}

export function HasEventSeriesUserReadAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.EVENT_SERIES_USER_READ}>{props.children}</HasAuthority>;
}

export function HasRegistrationCreateAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.REGISTRATION_CREATE}>{props.children}</HasAuthority>;
}

export function HasRegistrationWriteAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.REGISTRATION_WRITE}>{props.children}</HasAuthority>;
}

export function HasRegistrationReadAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.REGISTRATION_READ}>{props.children}</HasAuthority>;
}

export function HasEventCreateAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.EVENT_CREATE}>{props.children}</HasAuthority>;
}

export function HasEventWriteAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.EVENT_WRITE}>{props.children}</HasAuthority>;
}

export function HasEventReadAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.EVENT_READ}>{props.children}</HasAuthority>;
}

export function HasProgramCreateAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.PROGRAM_CREATE}>{props.children}</HasAuthority>;
}

export function HasProgramWriteAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.PROGRAM_WRITE}>{props.children}</HasAuthority>;
}

export function HasProgramReadAuthority(props: AnyObject) {
  return <HasAuthority authority={Authority.PROGRAM_READ}>{props.children}</HasAuthority>;
}
